import React, { FC } from "react";
import cn from "classnames";
import { CheckboxProps } from ".";
import Styles from "./forms.module.scss";

export const Checkbox: FC<CheckboxProps> = ({
  customClass = false,
  size = "md",
  label,
  id,
  ...props
}) => {
  const classes = cn(
    customClass || Styles.checkbox,
    size,
  );
  return (
    <label htmlFor={id} className={Styles.checkboxLabel}>
      <input
        id={id}
        className={classes}
        type="checkbox"
        {...props}
      />
      {label}
    </label>
  );
};

export default Checkbox;
